import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { LicenseTier } from './license-tier.model';

@JsonObject()
export class License {
  @JsonProperty('Id') id: string;
  @JsonProperty('OwnerId') ownerId: string;
  @JsonProperty('Tier') tier: LicenseTier;
  @JsonProperty('Quantity') quantity: number;
  @JsonProperty('StartDate') startDate: Date;
  @JsonProperty('EndDate') endDate: Date;
  @JsonProperty('StripeSubscriptionId') stripeSubscriptionId: string;
  @JsonProperty('HasLastPaymentFailed') hasLastPaymentFailed: boolean;
  @JsonProperty('Comment') comment: string;
  @JsonProperty('IsCanceled') isCanceled: boolean;
}
